import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Download } from "lucide-react";
import { exportToCSV, exportToExcel } from "../../lib/exporter";

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDocs(collection(db, "payments"));
        setPayments(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetch();
  }, []);

  const total = payments.filter((p) => p.paymentStatus === "success").reduce((s, p) => s + (Number(p.amount) || 0), 0);

  const buildExport = () =>
    payments.map((p) => ({
      "Payment ID": p.razorpayPaymentId,
      "Order ID": p.razorpayOrderId,
      "Student ID": p.studentId,
      "Email": p.email,
      "Plan": p.selectedPlan,
      "Amount": p.amount,
      "Currency": p.currency,
      "Status": p.paymentStatus,
      "Verified": p.verified,
    }));

  return (
    <div data-testid="admin-payments">
      <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">Payments</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">All Payments</h1>
          <p className="mt-1 text-slate-600">{payments.length} total · ₹{total.toLocaleString("en-IN")} revenue</p>
        </div>
        <div className="flex gap-2">
          <button onClick={() => exportToCSV(buildExport(), "payments.csv")} data-testid="export-payments-csv" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-slate-200 hover:bg-slate-50 text-sm font-semibold">
            <Download className="w-4 h-4" /> CSV
          </button>
          <button onClick={() => exportToExcel(buildExport(), "payments.xlsx", "Payments")} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold">
            <Download className="w-4 h-4" /> Excel
          </button>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-slate-500">Loading...</div>
        ) : payments.length === 0 ? (
          <div className="p-10 text-center text-slate-500" data-testid="no-payments">No payments yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-6 py-3 font-semibold">Payment ID</th>
                <th className="text-left px-6 py-3 font-semibold">Student</th>
                <th className="text-left px-6 py-3 font-semibold">Plan</th>
                <th className="text-left px-6 py-3 font-semibold">Amount</th>
                <th className="text-left px-6 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.id} className="border-t border-slate-100">
                  <td className="px-6 py-3 font-mono text-xs">{p.razorpayPaymentId || p.id}</td>
                  <td className="px-6 py-3">
                    <div className="font-medium text-slate-900">{p.studentId}</div>
                    <div className="text-xs text-slate-500">{p.email}</div>
                  </td>
                  <td className="px-6 py-3 text-slate-700">{p.selectedPlan}</td>
                  <td className="px-6 py-3 font-semibold">₹{p.amount}</td>
                  <td className="px-6 py-3">
                    <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-semibold capitalize">
                      {p.paymentStatus}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminPayments;
